module.exports = __webpack_public_path__ + "img/nadvorie_logo.7cd3b8d8.png";